import controlIcon from "../../../../../assets/images/member/control.svg";
import imsIcon from "../../../../../assets/images/member/ims.svg";
import pmsIcon from "../../../../../assets/images/member/panorama.svg";
import weatherIcon from "../../../../../assets/images/member/weather.svg";
import pilotIcon from "../../../../../assets/images/member/pilot.svg";

export enum LicenseType {
    PILOT = 100,
    PMS = 101,
    CONTROL_SYSTEM = 102,
    IMS = 103,
    WEATHER = 104
}

export const LicenseTypeList = [
    {
        type: LicenseType.CONTROL_SYSTEM,
        name: "DFOS Control System",
        icon: controlIcon,
        isFree: false
    },
    {
        type: LicenseType.IMS,
        name: "DFOS IMS",
        icon: imsIcon,
        isFree: false
    },
    {
        type: LicenseType.PMS,
        name: "DFOS PMS",
        icon: pmsIcon,
        isFree: false
    },
    {
        type: LicenseType.WEATHER,
        name: "DFOS Weather",
        icon: weatherIcon,
        isFree: true
    },
    {
        type: LicenseType.PILOT,
        name: "DFOS Pilot",
        icon: pilotIcon,
        isFree: true
    }
];

export const getLicenseName = (type: LicenseType) => {
    return LicenseTypeList.find((licenseType) => licenseType.type === type)?.name;
}